export function formatMoney(
  value: number | null | undefined,
  currency = "CAD",
): string {
  if (value === null || value === undefined || Number.isNaN(value)) {
    return "Incomplete";
  }

  return new Intl.NumberFormat("en-CA", {
    style: "currency",
    currency,
    maximumFractionDigits: 2,
  }).format(value);
}

export function formatPercent(value: number | null | undefined): string {
  if (value === null || value === undefined || Number.isNaN(value)) {
    return "Incomplete";
  }

  return value.toFixed(1) + "%";
}

export function previousPeriodComparison(
  current: number | null | undefined,
  previous: number | null | undefined,
  previousRange?: { from?: string | null; to?: string | null } | null,
): string | null {
  if (
    current === null ||
    current === undefined ||
    previous === null ||
    previous === undefined
  ) {
    return null;
  }

  const rangeSuffix =
    previousRange?.from && previousRange?.to
      ? ` (${previousRange.from} – ${previousRange.to})`
      : "";

  if (previous === 0) {
    return current === 0
      ? `No change from previous period${rangeSuffix}`
      : `New vs previous period${rangeSuffix}`;
  }

  const change = ((current - previous) / Math.abs(previous)) * 100;
  if (change === 0) {
    return `No change from previous period${rangeSuffix}`;
  }

  return `${Math.abs(change).toFixed(1)}% ${
    change > 0 ? "up" : "down"
  } from previous period${rangeSuffix}`;
}

export function knownMoney(
  value: number | null | undefined,
  known: number,
  currency = "CAD",
): string {
  return value === null || value === undefined
    ? `Known: ${formatMoney(known, currency)}`
    : formatMoney(value, currency);
}
